import { RoomService } from "@/services/room.service"
import { mapGetters } from "vuex";
export const roomMixin = {
    data() {
        return {
            schoolRooms: [],
            rooms: [],
            loading: false,
            errored: false,
        };
    },
    created() {
        this.fetchData();
    },
    computed: {
        ...mapGetters({

        }),
        noSchoolRoomsSet() {
            return this.schoolRooms.length === 0;
        },
    },
    methods: {
        fetchData() {
           RoomService.getRooms()
              .then((response) => (this.rooms = response.data.data))
              .catch((err) => {
                console.log("rooms " + err);
                this.errored = true;
              })
              .finally(() => this.fetchSchoolRooms());
          },
          fetchSchoolRooms() {
            RoomService.getSchoolRooms()
              .then((response) => (this.schoolRooms = response.data.data))
              .catch((err) => {
                console.log("rooms " + err);
                this.errored = true;
              })
              .finally(() => (this.loading = false));
          },
          inSchoolRooms(identifier) {
            var found = this.schoolRooms.find((y) => y.identifier === identifier);
            return found === undefined ? false : true;
          },
          selectSchoolRoom(room) {
            if (this.inSchoolRooms(room.identifier)) {
                RoomService.delete(room)
                .then((response) => this.completion())
                .catch((err) => {
                  console.log(err);
                });
            } else {
                RoomService.add(room)
                .then((response) => {
                  this.completion();
                })
                .catch((err) => {
                  console.log(err);
                });

            }
          },
          completion() {
            this.fetchSchoolRooms()
          }

    }
};
